import { Link, NavLink } from "react-router-dom";
import { FaHome, FaJournalWhills, FaTicketAlt } from "react-icons/fa";
import { CgNotes } from "react-icons/cg";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { useSelector } from "react-redux";

const AppBar = () => {
  const { user } = useSelector((state) => state.user);
  return (
    <>
      {user !== null && (
        <div className="container p-2">
          <div className="notice-board p-2 mt-2" style={{ cursor: "pointer" }}>
            <marquee behavior="" direction="left">
              <p className="text-white">
                <span className="fw-bold">Recommend a friend or family </span>
                <span className="me-2">
                  and Earn extra income, if you know someone who is being
                  harassed or struggling with their debts
                </span>
                <span className="fw-bold">
                  <LiaRupeeSignSolid /> 1,000 for anyone who enrols with us.
                  Click here.{" "}
                </span>
              </p>
            </marquee>
          </div>

          <div className="mt-4">
            <h2 className="text-md-center">Welcome back {user.Full_Name}</h2>
            <div className="d-flex align-items-end justify-content-between gap-4 flex-wrap">
              <div>
                <p className="text-capitalize fw-bold">
                  Account manager:{" "}
                  {user.Account_Manager && user.Account_Manager.name}
                </p>
                <p className="text-capitalize fw-bold">
                  Unique reference number:{" "}
                  <span className="text-uppercase">{user.Lead_Unique_ID}</span>
                </p>
              </div>
              {user.CIBIL_Check === true && (
                <Link
                  to="/user_cibil"
                  className="button d-inline-block text-center ms-auto"
                  style={{ minWidth: "160px" }}
                >
                  Check CIBIL data
                </Link>
              )}
            </div>
          </div>

          <ul className="tab mt-4 list-unstyled">
            <li className="active">
              <NavLink to="/" className="white-button">
                <FaHome />
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/todo" className="white-button">
                <CgNotes />
                <span>To Do list</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/journal" className="white-button">
                <FaJournalWhills />
                Journal
              </NavLink>
            </li>
            <li>
              <NavLink to="/activity" className="white-button">
                <FaJournalWhills />
                Activity
              </NavLink>
            </li>
            <li>
              <NavLink to="/ticket" className="white-button">
                <FaTicketAlt />
                Tickets
              </NavLink>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default AppBar;
